<!--singleSvg 这是单独打开的svg界面,指定图的-->

<template>
  <div class="singleSvg kanban">
    <div class="tit">
      <img src="./img/top.png" style="width: 100%;" />
      <div class="name">
        <div class="time">{{ time }}</div>
        <div
          class="t"
          style="width: 20%;text-align: center;color: #fff;font-size: 34px;line-height: 0px;"
        >
          {{ named }}
        </div>
        <div class="f">
          <img
            src="./img/xiao.png"
            v-if="fullscreen"
            @click="handleFullScreen"
          />
          <img src="./img/da.png" v-else @click="handleFullScreen" />
        </div>
      </div>
    </div>
    <div class="select">
      <div class="left">
        当前区域: <span style="color: #0085ff;">{{ list.areaName }}</span>
      </div>
      <div class="medio">
        <div class="boxed">
          <img src="./img/gonglv.png" alt="" />
          总功率:
          <span class="num">{{ list.powerTotal }}</span>
          kw
        </div>
        <div
          class="boxed"
          style="border-color: #0085FF;background: linear-gradient(90deg, #173E7866 0%, #173E7800 100%);"
        >
          <img src="./img/dian.png" alt="" />
          总电量:
          <span class="num" style=" color: #0085FF; ">{{
            list.energyTotal
          }}</span>
          kwh
        </div>
      </div>
      <div class="right">
        <el-radio-group v-model="radio1" @change="getList" size="mini">
          <el-radio-button label="DAY">日</el-radio-button>
          <el-radio-button label="MONTH">月</el-radio-button>
          <el-radio-button label="YEAR">年</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="box">
      <span class="search"> </span>
      <!-- 内容 -->
      <span class="content">
        <div class="ul">
          <div class="li" v-for="(b, i) in list.children" :key="i">
            <div class="t">{{ b.areaName }}</div>
            <div class="a">
              <span>功率kw:</span>
              <div class="num">{{ b.powerTotal }}</div>
            </div>
            <div class="b">
              <span>电量kwh:</span>
              <div class="num">{{ b.energyTotal }}</div>
            </div>
          </div>
        </div>
      </span>

      <div class="el-loading-mask" v-show="isMask">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/api/http.js";
import { parseTime } from "@/utils";
export default {
  props: [],
  data() {
    return {
      named: getName(),
      time: "",
      value: "1",
      fullscreen: false,
      setIntervalTimer: "",
      setIntervalTimer2: "",
      isMask: false,
      list: {
        id: "4fd1662ca7ce4902ab96b3fc99117afb",
        areaName: "南园区",
        energyTotal: 334678.22,
        powerTotal: 27124,
        children: [
          {
            id: "1951f49dbdcb40da9acfceadf140691b",
            areaName: "五厂一(C栋)",
            energyTotal: 49019.0,
            powerTotal: 3265.4,
            children: null,
          },
          {
            id: "89896d2a739a4e88afd2ca1b5aeedc31",
            areaName: "五厂一部--(配料)",
            energyTotal: 359.85,
            powerTotal: 3.7,
            children: null,
          },
          {
            id: "43fc8d5856e247859683d3693c86ebfb",
            areaName: "五厂一部--(涂布)",
            energyTotal: 3513.5,
            powerTotal: 184.01,
            children: null,
          },
          {
            id: "5ff7e4d49d30466f8714952d64277310",
            areaName: "五厂一部--(辊压)",
            energyTotal: 1462.5,
            powerTotal: 94.56,
            children: null,
          },
          {
            id: "779c5e288c9c4412a0614d01e316344f",
            areaName: "五厂三部--(卷绕)",
            energyTotal: 7775.39,
            powerTotal: 610.95,
            children: null,
          },
          {
            id: "54039e2af0b5404287c87651370b90f1",
            areaName: "五厂三部--(注液)",
            energyTotal: 0,
            powerTotal: 0,
            children: null,
          },
          {
            id: "2a854a388d7e468eb698ce1440c8c36c",
            areaName: "五厂三部--(ACT)",
            energyTotal: 4477.39,
            powerTotal: 360.88,
            children: null,
          },
          {
            id: "1e843908adad4d62bf030e3a9aac2743",
            areaName: "五厂三部--(OCV)",
            energyTotal: 0,
            powerTotal: 0,
            children: null,
          },
          {
            id: "b507a32c3b80433b8f69525669905a81",
            areaName: "五厂三部-.(包装)",
            energyTotal: 430.0,
            powerTotal: 32.85,
            children: null,
          },
          {
            id: "4c0e22d18c844ab4b9eaba27bc9524e9",
            areaName: "五厂四部--(制片)",
            energyTotal: 0,
            powerTotal: 0,
            children: null,
          },
          {
            id: "21403e92c07448cc8dc767932b7a4931",
            areaName: "五厂四部--(卷绕)",
            energyTotal: 13.1,
            powerTotal: -1.5,
            children: null,
          },
          {
            id: "749374e4bf7b4780946d0c704c38b904",
            areaName: "五厂四部--(注液)",
            energyTotal: 2162.25,
            powerTotal: 167.05,
            children: null,
          },
          {
            id: "81be22cd858944eb84c0b04cf498a468",
            areaName: "五厂四部--(化成)",
            energyTotal: 21.8,
            powerTotal: -3.5,
            children: null,
          },
          {
            id: "92fd6ea9349249e59e125dbaa6b92e5b",
            areaName: "五厂四部--(二封)",
            energyTotal: 2133.25,
            powerTotal: 166.9,
            children: null,
          },
          {
            id: "3502a5a3e1b84c42be21e603b3867762",
            areaName: "五厂四部--(分选)",
            energyTotal: 95.0,
            powerTotal: -11.5,
            children: null,
          },
          {
            id: "9cdc856a9d834648b9ba4bf8ef386ed8",
            areaName: "五厂三部--(化成)",
            energyTotal: 0,
            powerTotal: 0,
            children: null,
          },
          {
            id: "97119ae8a7b74e67a791fea05004f694",
            areaName: "五厂四部--(OCV)",
            energyTotal: 0,
            powerTotal: 0,
            children: null,
          },
          {
            id: "59490961f2b54bc09d837ad7d4448f33",
            areaName: "五厂四部--(包装)",
            energyTotal: 2644.0,
            powerTotal: 213.85,
            children: null,
          },
          {
            id: "d00fa3460c3f4faebae5d25827d0f471",
            areaName: "七厂一(A栋)",
            energyTotal: 46331.0,
            powerTotal: 3929.62,
            children: null,
          },
          {
            id: "1a1f9acb48a947bba38e52522122cfcf",
            areaName: "七厂一(B栋)",
            energyTotal: 21910.0,
            powerTotal: 1657.1,
            children: null,
          },
          {
            id: "54eb907937784e529ffb35c4b03748ae",
            areaName: "七厂-(实验室)",
            energyTotal: 6200.0,
            powerTotal: 485.25,
            children: null,
          },
          {
            id: "5a5c8cc633cc4b59b21fc6150109451c",
            areaName: "七厂-部-(配料",
            energyTotal: 2685.0,
            powerTotal: 285.45,
            children: null,
          },
          {
            id: "6ed1943bae244532a57f4b629c3b792d",
            areaName: "七厂-部--(涂布)",
            energyTotal: 8895.0,
            powerTotal: 829.35,
            children: null,
          },
          {
            id: "2fc4f95905a84b3dbb896f7b4942ece1",
            areaName: "七厂一部-《辊压)",
            energyTotal: 1570.0,
            powerTotal: 104.55,
            children: null,
          },
          {
            id: "77e2da5dc8e84a7ea4aec836fba0d3c6",
            areaName: "七厂三部--(卷绕)",
            energyTotal: 0,
            powerTotal: 0,
            children: null,
          },
          {
            id: "334392c0cf96429e927bd6117a74095a",
            areaName: "七厂三部--(注液)",
            energyTotal: 0,
            powerTotal: 0,
            children: null,
          },
          {
            id: "938255c0138841ebb3a13d27e600481d",
            areaName: "七厂三部--(化成)",
            energyTotal: 0,
            powerTotal: 7.45,
            children: null,
          },
          {
            id: "f2ae069b159d47009aa6a17f8a1f88e9",
            areaName: "七厂三部--(二封)",
            energyTotal: 1105.0,
            powerTotal: 87.8,
            children: null,
          },
          {
            id: "c6d3f03ed31a442f872390d91d660db0",
            areaName: "七厂三部--(ACT)",
            energyTotal: 505.0,
            powerTotal: 29,
            children: null,
          },
          {
            id: "df1dfd932b614a1b8916ce929148a063",
            areaName: "七厂三部- (OCV)",
            energyTotal: 0,
            powerTotal: 0,
            children: null,
          },
          {
            id: "f3668b4147e34815be30265830114de1",
            areaName: "七厂三部-(包装)",
            energyTotal: 0,
            powerTotal: 0,
            children: null,
          },
          {
            id: "2fbf65fbbcff426293470b19668e56d5",
            areaName: "七厂四部--(制片)",
            energyTotal: 0,
            powerTotal: 0,
            children: null,
          },
          {
            id: "3cea30132d3d4b9c97606a1039b28799",
            areaName: "七厂四部--(卷绕)",
            energyTotal: 4985.0,
            powerTotal: 417.75,
            children: null,
          },
          {
            id: "e65c448aa6e34c2dbd7782d8861c1a53",
            areaName: "七厂四部--(注液)",
            energyTotal: 420.0,
            powerTotal: 34.5,
            children: null,
          },
          {
            id: "634c4558e2b849e38909dc51bf0112e2",
            areaName: "七厂四部--(化成)",
            energyTotal: 2785.0,
            powerTotal: 229.45,
            children: null,
          },
          {
            id: "bc858e8a0bb1440780dd9e1be0964831",
            areaName: "七厂四部-(二封)",
            energyTotal: 2715.0,
            powerTotal: 230.6,
            children: null,
          },
          {
            id: "c81efd59344d49e19e41acfe3680ab94",
            areaName: "七.厂四部-(分选)",
            energyTotal: 0,
            powerTotal: 0,
            children: null,
          },
          {
            id: "7d65328f25e54da798320195ba290ead",
            areaName: "七厂四部-(OCV)",
            energyTotal: 0,
            powerTotal: 0,
            children: null,
          },
          {
            id: "2ad6a9e0cca54faba1eb6b507b34d19b",
            areaName: "七厂四部-(包装)",
            energyTotal: 0,
            powerTotal: 0,
            children: null,
          },
          {
            id: "24e643c6cc4d4572b6248320e079d42c",
            areaName: "动力一(C栋)",
            energyTotal: 3431.0,
            powerTotal: 276.8,
            children: null,
          },
          {
            id: "4fc980bf52bc4504acc6fcba50004aa2",
            areaName: "钢壳-(C栋)",
            energyTotal: 1100.0,
            powerTotal: 91.2,
            children: null,
          },
          {
            id: "f539f5f120b2427d9e90f725c182dd0c",
            areaName: "五厂三部--(二封)",
            energyTotal: 0,
            powerTotal: 0,
            children: null,
          },
        ],
      },
      radio1: "DAY",
    };
  },
  destroyed() {
    clearInterval(this.setIntervalTimer);
    clearInterval(this.setIntervalTimer2);
  },
  mounted() {
    this.setIntervalTimer2 = setInterval(() => {
      this.time = parseTime(new Date(), "{y}-{m}-{d} {h}:{i}:{s}");
    }, 1000);

    this.getList();
    this.setIntervalTimer = setInterval(() => {
      if (this.radio1 == "DAY") {
        this.getList();
      }
    }, 600000);
  },
  methods: {
    // 全屏事件
    handleFullScreen() {
      // 此处可根据获取节点进行区域全屏事件
      let element = document.getElementsByClassName("kanban")[0];
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    getMath(index) {
      if (!index) {
        index = 0;
      }

      var min = Math.ceil(index - index / 10); // 确保min是整数
      var max = Math.floor(index + index / 10); // 确保max是整数
      return Math.floor(Math.random() * (max - min + 1)) + min; // 返回介于min和max之间的整数
    },
    getList() {
      // "energyTotal": 334678.22,
      // "powerTotal": 27124,
      this.list.energyTotal = this.getMath(this.list.energyTotal);
      this.list.powerTotal = this.getMath(this.list.powerTotal);
      this.list.children.map((v) => {
        v.energyTotal = this.getMath(v.energyTotal);
        v.powerTotal = this.getMath(v.powerTotal);
      });
    },
  },
};
</script>

<style scoped>
.medio {
  display: flex;
  justify-content: space-between;
  width: 600px;
  transform: translateX(5px);
}

.medio .boxed {
  display: flex;
  align-items: center;
  border-radius: 28px 0px 0px 28px;
  background: linear-gradient(90deg, #844a1566 0%, #844a1500 100%);
  padding: 8px;
  border: 1px solid #b8671e;
  border-right: none;
}

.medio .boxed img {
  margin-right: 20px;
}

.medio .boxed .num {
  color: #ff9635;
  font-family: Arial;
  font-weight: bold;
  font-size: 22px;
  margin: 0 12px;
}

.name {
  display: flex;
  position: absolute;
  top: 30px;
  width: 99%;
  justify-content: space-between;
}

.name .time {
  margin-left: 12px;
  margin-top: 15px;
  width: 200px;
  color: #a6d4ff;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 16px;
}

.name .f {
  margin-right: 12px;
  margin-top: 15px;
  width: 200px;
  display: flex;
  justify-content: end;
}

.name .f img {
  cursor: pointer;
}

.select {
  color: #999999;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.select .sel {
  width: 100px;
}

.search {
  display: flex;
  justify-content: flex-end;
  padding: 15px;
  padding-right: 30px;
}

.singleSvg {
  background: #0a1927;
  position: relative;
}

.singleSvg .box {
  width:99%;
}

.ul {
  display: flex;
  flex-wrap: wrap;
  padding-left: 5px;
}

.ul .li {
  width: calc((100% / 7) - 13px);
  height: 78px;
  margin-right: 12px;
  margin-bottom: 12px;
  border-radius: 6px;
  background: #0c2741;
  border: 1px solid #123c6c;
  color: #fff;
}

.ul .li:nth-child(7n) {
  margin-right: 0;
}

.ul .li .t {
  width: 100%;
  font-size: 15px;
  margin-top: 5px;
  font-weight: bold;
  padding-left: 12px;
}

.ul .li .a {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  margin-top: 5px;
}

.ul .li .a span {
  font-size: 13px;
  padding-left: 12px;
}

.ul .li .a .num {
  flex: 1;
  font-size: 16px;

  padding-left: 10px;
  color: #ff9635;
  font-family: Arial;
  font-weight: bold;
}

.ul .li .b {
  display: flex;
  align-items: center;
}

.ul .li .b span {
  font-size: 13px;
  padding-left: 12px;
}

.ul .li .b .num {
  flex: 1;
  font-size: 14px;
  font-weight: bold;
  padding-left: 10px;
  color: #0085ff;
  font-family: Arial;
}
</style>
